import Api from "../service/Api";

class AudioRepository {
  fetch(query) {
    return Api.get("/audios", query);
  }
}
export default AudioRepository;
